var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "content-loader",
    {
      attrs: {
        height: 408,
        width: 288,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "16",
          y: "16",
          rx: "0",
          ry: "0",
          width: "256",
          height: "256"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "16",
          y: "315",
          rx: "0",
          ry: "0",
          width: "256",
          height: "17"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "16",
          y: "288",
          rx: "0",
          ry: "0",
          width: "81.65",
          height: "17"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "196",
          y: "371",
          rx: "0",
          ry: "0",
          width: "74.85",
          height: "33.35"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "16",
          y: "345.05",
          rx: "0",
          ry: "0",
          width: "156.64",
          height: "17"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "86",
          y: "390.05",
          rx: "0",
          ry: "0",
          width: "0",
          height: "0"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "16",
          y: "379.05",
          rx: "0",
          ry: "0",
          width: "73",
          height: "16"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e68f6c6", { render: render, staticRenderFns: staticRenderFns })
  }
}